export default __webpack_public_path__ + "dfc66e0f64adb5ed7de2bf3540ebeb44.svg";